import WalletConnect from '../../src/legacy/WalletConnect.tsx';
export default WalletConnect;
